import React from 'react';
import PageTemplate from '../../components/template/PageTemplate';
import { FeatureFlagContainer } from '../../containers/system/FeatureFlagContainer';
import { FEATURE_FLAG_PAGE_NAME } from '../../constants/service/app/featureFlagConstants';

/**
 * 서버 피처 플래그 페이지 (백엔드 AMZBM-136).
 *
 * 이 admin 이 붙은 환경(dev · prod) 의 서버 플래그를 켜고 끈다. prod 에서 켜는 것이 곧 출시다.
 * 어느 환경을 바꾸는지 눈에 보이게 하는 것이 이 화면의 핵심이다.
 */
const FeatureFlag = (): React.JSX.Element => {
  return (
    <PageTemplate pageName={FEATURE_FLAG_PAGE_NAME.MAIN}>
      <FeatureFlagContainer />
    </PageTemplate>
  );
};

export default FeatureFlag;
